import * as stylex from "@stylexjs/stylex";
/**
 * CSS custom properties for the per-article document theme (`themes` in `./theme.ts`).
 * Only the fields actually consumed as CSS values are exposed here — `palette` (mostly D3
 * chart-scale data) and `illustration` (a plain image asset) stay on `useActiveTheme()`.
 * Values below are precomputed with `lighten`/`darken` from `lib/colorManipulator` to match
 * `./theme.ts` exactly — each theme below mirrors the source theme of the same name.
 */ export const themeVars = {
    textColor: "var(--x1tgejs6)",
    backgroundMain: "var(--xdcjhey)",
    backgroundLight: "var(--xjlicte)",
    backgroundDark: "var(--x5max2w)",
    __varGroupHash__: "x1lga1z"
};
// stylex.createTheme() calls must each be bound to their own bare variable — they can't be
// written inline inside the documentThemes object below.
const defaultTheme = {
    x1lga1z: "x1jo2flr x1lga1z",
    $$css: true
};
const accessTheme = {
    x1lga1z: "x1295p5x x1lga1z",
    $$css: true
};
const equityTheme = {
    x1lga1z: "x1udr7z0 x1lga1z",
    $$css: true
};
const learningTheme = {
    x1lga1z: "xiebh2j x1lga1z",
    $$css: true
};
const trajectoriesTheme = {
    x1lga1z: "xiebh2j x1lga1z",
    $$css: true
};
const qualityTheme = {
    x1lga1z: "xcihtjv x1lga1z",
    $$css: true
};
const financeTheme = {
    x1lga1z: "x14ug1l4 x1lga1z",
    $$css: true
};
const financeAidTheme = {
    x1lga1z: "x14ug1l4 x1lga1z",
    $$css: true
};
export const documentThemes = {
    default: defaultTheme,
    access: accessTheme,
    equity: equityTheme,
    learning: learningTheme,
    trajectories: trajectoriesTheme,
    quality: qualityTheme,
    finance: financeTheme,
    "finance-aid": financeAidTheme
};
